import Footer from '@/components/Footer';
import { FashionHero } from '@/components/home/FashionHero';
import { FashionTicker } from '@/components/home/FashionTicker';
import { EditorialSpread } from '@/components/home/EditorialSpread';
import { DropEdit } from '@/components/home/DropEdit';
import { DropCountdown } from '@/components/home/DropCountdown';

export default function Home() {
  return (
    <main className="relative bg-transparent" data-testid="home-page">
      <FashionHero />
      <FashionTicker />
      <DropCountdown />
      <EditorialSpread />
      <DropEdit />
      <section className="bg-[#C7D1C3]/90 px-5 py-20 backdrop-blur-sm sm:px-8 lg:px-12 lg:py-28" data-testid="brand-statement-section">
        <div className="mx-auto flex max-w-[1500px] flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <h2 className="max-w-5xl font-syne text-4xl font-extrabold uppercase leading-[0.9] sm:text-5xl lg:text-6xl">
            No filler.<br />Only favorites.
          </h2>
          <p className="max-w-xs text-sm leading-relaxed text-[#454545]">
            Designed in small runs for big personalities. Wear it often. Style it differently every time.
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
}